(function() {

  // Discount Codes die KEINEN Banner auslösen sollen
  const excludedDiscounts = [
    'WELCOME10',
    'FIRSTORDER',
    'INTERNAL'
    // Füge hier weitere Codes hinzu, die keinen Banner zeigen sollen
  ];

  // Cookie Funktionen
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Prüfe ob wir auf einer /discount/ Seite sind
  const currentPath = window.location.pathname;
  const discountMatch = currentPath.match(/\/discount\/([^\/]+)/);
  
  if (discountMatch) {
    const code = discountMatch[1];
    
    // Setze Cookie für 30 Tage (für alle Codes)
    setCookie('discount_code', code, 30);
    
    // Hole redirect Parameter
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirect');
    
    // Redirect zur Zielseite
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = '/'; // Fallback zur Homepage
    }
  }

  // Zeige Banner an, wenn Cookie existiert UND Code nicht auf Negativliste
  const discount_code = getCookie('discount_code');
  const banner_dismissed = sessionStorage.getItem('discount_banner_dismissed');
  
  // Prüfe: Code existiert UND ist nicht in der Ausschlussliste UND Banner wurde nicht geschlossen
  if (discount_code && !excludedDiscounts.includes(discount_code) && !banner_dismissed) {
    
    // Prüfe ob Banner-Element existiert
    let banner = document.getElementById('discount-banner');
    
    if (banner) {
      banner.innerHTML = "Dein CODE <b>" + discount_code + "</b> wurde aktiviert! 🎉 <span id='close-banner' style='cursor: pointer; margin-left: 15px; font-size: 20px;'>×</span>";
      banner.style.display = 'block';
    } else {
      // Erstelle Banner wenn nicht vorhanden
      banner = document.createElement('div');
      banner.id = 'discount-banner';
      banner.style.cssText = 'background: #2BA9BE; color: white; text-align: center; padding: 15px; font-weight: bold; position: relative; top: 0; z-index: 1000;';
      banner.innerHTML = "Dein CODE <b>" + discount_code + "</b> wurde aktiviert! 🎉 <span id='close-banner' style='cursor: pointer; margin-left: 15px; font-size: 20px;'>×</span>";
      document.body.insertBefore(banner, document.body.firstChild);
    }
    
    // Close Button Event
    const closeButton = document.getElementById('close-banner');
    if (closeButton) {
      closeButton.addEventListener('click', function() {
        banner.style.display = 'none';
        sessionStorage.setItem('discount_banner_dismissed', 'true');
      });
    }
  }

})();